import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, ShieldCheck } from "lucide-react";
import { authHeader, formatApiErrorDetail, useAuth } from "../../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "w-full border border-[#E3DED4] rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:border-[#B85D2A]";

export const AccountSettings = () => {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("New passwords do not match.");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: next }, { headers: authHeader() });
      toast.success("Password updated. Use the new password next time you sign in.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md">
      <h2 className="font-serif text-xl text-[#142D44]">Account & Security</h2>
      <p className="text-xs text-[#718096] mt-1 mb-6">Signed in as <span className="font-medium text-[#142D44]">{user?.email}</span></p>
      <form onSubmit={submit} className="bg-white border border-[#E3DED4] border-t-4 border-t-[#B85D2A] rounded-xl p-7 space-y-4" data-testid="change-password-form">
        <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8C6B4F]">
          <KeyRound size={13} /> Change Password
        </p>
        <div>
          <label className="block text-xs font-medium text-[#526071] mb-2">Current Password</label>
          <input data-testid="current-password-input" type="password" className={inputCls} value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div>
          <label className="block text-xs font-medium text-[#526071] mb-2">New Password (min 8 characters)</label>
          <input data-testid="new-password-input" type="password" className={inputCls} value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div>
          <label className="block text-xs font-medium text-[#526071] mb-2">Confirm New Password</label>
          <input data-testid="confirm-password-input" type="password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <button
          type="submit"
          disabled={busy || !current || !next || !confirm}
          data-testid="change-password-button"
          className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-lg bg-[#1E3A5F] text-white text-sm font-medium hover:bg-[#B85D2A] transition-colors disabled:opacity-50"
        >
          <ShieldCheck size={15} /> {busy ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
};
